module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "foreword",
      "id": "_idContainer008",
      "role": "doc-foreword"
    }
  }, [_c('h1', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Historical Note")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "lic"
  }, [_vm._v("I")]), _vm._v("n the thirteenth century marriage was regarded very differently from the way it is today. For the nobility it had little to do with love, but was a way of gaining power and influence and even making fortunes.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Betrothals could take place when the future bride and groom were still babies. Under canon law, the legal age for marriage was twelve years old for girls and fourteen for boys, although some marriages took place even earlier. However, these could later be challenged in Church Court.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("In the majority of cases consummation was delayed until the bride began menstruating, and could therefore potentially provide an heir, but noblewomen rarely had any choice in the identity of the man they would marry—the husband who would effectively own them for the rest of their lives.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("In 1200, a year after ascending to the English throne, King John married Isabella, the daughter of the Count of Angoulême, having dissolved his first marriage to Isabella of Gloucester on the grounds of consanguinity. Historians estimate Isabella to have been twelve years old—John was thirty-three.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Controversially, she was already betrothed to Hugh IX le Brun, Lord of Lusignan and Count of La Marche, who appealed to King Philip Augustus of France in protest, thus beginning the hostilities that led to the loss of so much English territory over the channel.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was this territory that John attempted to reclaim in 1214, leading to the disastrous Battle of Bouvines on 27th July and the First Barons’ War of 1215.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61e1f802","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Historical_Note.vue
// module id = 75
// module chunks = 0